import axios from 'axios';

export default {
  state: {
    aggregated_document_results: {},
    fraud_summary: {},
    fraud_report: {},
    signalsByCustomerUUID: {},
  },
  actions: {
    fetchAndCacheFraudSummary(context, { customerId }) {
      return axios
        .get(`api/v2/customers/${customerId}/fraud_summary`)
        .then((response) => {
          context.state.fraud_summary[customerId] = response.data.data;
        });
    },
    fetchAndCacheAggregatedDocumentResults(context, { customerId }) {
      return axios
        .get(`api/v2/customers/${customerId}/aggregated_document_results/`)
        .then((response) => {
          context.state.aggregated_document_results[customerId] =
            response.data.data;
        });
    },
    fetchAndCacheCustomerSignalsForCustomerUUID(context, { customerId }) {
      return axios
        .get(`api/v2/customers/${customerId}/signals/`)
        .then((response) => {
          context.state.signalsByCustomerUUID[customerId] = response.data;
        });
    },
    fetchAndCacheFraudReport(context, { customerId }) {
      return axios
        .get(`api/v2/internal/customers/${customerId}/fraud-report`)
        .then((response) => {
          context.state.fraud_report[customerId] = response.data;
        });
    },
    generateFraudReport(context, { customerId }) {
      return axios.post(`api/v2/internal/customers/${customerId}/fraud-report`);
    },
  },
  getters: {
    getCachedFraudSummary(state) {
      return (customerId) => {
        return state.fraud_summary[customerId];
      };
    },
    getCachedAggregatedDocumentResults(state) {
      return (customerId) => {
        return state.aggregated_document_results[customerId];
      };
    },
    getCachedCustomerSignalsById(state) {
      return (customerId) => {
        return state.signalsByCustomerUUID[customerId];
      };
    },
    getCachedFraudReport(state) {
      return (customerId) => {
        return state.fraud_report[customerId];
      };
    },
  },
};
